export const MINIMUM_ORDER_VALUE = 499;
